module.exports = __webpack_public_path__ + "9a9b6f87ee94a17aa4ea1737b8116c9e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg70.jpeg
// module id = 84
// module chunks = 0